/**
 * created by tian ruo jun
 发布时同步投稿至其他单位及媒体
 *
 */
import React, {Component} from 'react';
import {Icon, Input, Tree, DatePicker, Select, message} from 'antd'
import SwitchBounced from "../../components/switchBounced/SwitchBounced"
import '../EditorPublishInformation.css'
import Concurrently from "../concurrently/Concurrently";
import BaseComponent from "../../../../base/BaseComponent";

const {TreeNode} = Tree;
const {Search} = Input;
const getNodesUrl = "/cm-sites-pms/contribute/nodes";
const collectUrl = "/cm-sites-pms/contribute/collect";
const cancelCollectionUrl = "/cm-sites-pms/contribute/cancel";
export default class SynchronousContribute extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            meanWhile: false,
            synchronize: true,
            contribute: true,
            properties: true,
            orso: true,
            switchShow: false,
            // 搜索框内容
            searchText:"",
            // 展开的节点树
            expandedKeys:[],
            // 搜索到的key
            searchExpandedKeys:[],
            // 展开的节点
            selectedKeys:[],
            // 选中的节点
            checkedKeys:[],
            publishInformation: {
                currentColumn: [],//当前栏目
                numerical: '',//重要性
                location: '',//显示位置
                frequency: '',//点击次数
                accretion: [],//同步数据
            },
            treeData: []
        }
    }

    componentWillMount() {
        this.getNodes()
    }

    componentDidMount() {
    }

    getCheckedKeys = () => {
        return this.state.checkedKeys
    };

    setCheckedKeys = (checkedKeys) => {
        this.setState({
            checkedKeys
        })
    };

    getNodes = () => {
        this.request({
            url: getNodesUrl,
            callBack: (res) => {
                let treeData = [];
                if (res) {
                    treeData = res;
                }
                this.setState({treeData})
            },
            errorCallBack: (e) => {
                this.setState({treeData: []})
            }
        })
    };

    render() {
        const {contribute, treeData} = this.state;
        let floor = 0;
        return (
            <>
                <div className="synchronize">
                    <div className="overstriking">同步投稿至</div>
                    <div><Icon className="lineIcon" type={contribute ? "down" : "up"}
                               onClick={this.contributeTree}/>
                    </div>
                </div>
                <Search
                    placeholder="请输入关键词"
                    onSearch={value => this.onChange(value)}
                    style={{ margin:"10px 0"}}
                />
                {contribute ?
                    <div>
                        <Tree
                            showIcon
                            checkable
                            // defaultExpandedKeys={['0-0-0', '0-0-1']}//默认展开指定的树节点
                            // defaultSelectedKeys={['0-0-1-1']}//默认选中的树节点
                            // defaultCheckedKeys={['0-0-1-1']}//默认选中复选框的树节点
                            defaultExpandParent={true}
                            defaultExpandAll={true}
                            expandedKeys={this.state.expandedKeys}
                            autoExpandParent={this.state.autoExpandParent}
                            checkedKeys={this.state.checkedKeys}
                            // selectedKeys={this.state.selectedKeys}
                            onExpand={this.onExpand}
                            onSelect={this.onSelect}
                            onCheck={this.onCheck}
                        >
                            {this.renderTreeNodes(treeData,floor)}
                        </Tree>
                    </div> : ''
                }
            </>
        )
    }

    renderTreeNodes = (data,floor) =>
        data.map(item => {
            if (item.child) {
                return (
                    <TreeNode title={this.renderTitle("folder-open", item,floor)} key={item.id} dataRef={item}>
                        {this.renderTreeNodes(item.child,floor+1)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id} title={this.renderTitle("file-text", item,floor)}/>;
        });

    renderTitle = (type, item, floor) => {
        const index = this.state.searchText.length > 0 ? item.name.indexOf(this.state.searchText) : -1;
        let width1 = 190 - floor*19;
        let width2 = 160 - floor*19;
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: width1,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Icon type={type}/>
                    <span style={{width:width2,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        color: index > -1 ? '#f50' : 'unset'
                    }}
                    >{item.name}</span>
                </div>
                <div onClick={()=>{this.setCollect(item)}}>{item.collect ? <Icon type="star" theme="filled" style={{color:"#f0a738"}} /> : <Icon type="star" />}</div>
            </div>
        )
    };

    //搜索框输入变化的时候调用为提高性能，去掉了输入内容变化后调用改为点击搜索或者enter调用
    onChange(textValue) {
        if (textValue.length < 0) {
            this.state.expandedKeys = []
        }
        {
            this.state.searchExpandedKeys = [];
            this.getSearchOpenKey(this.state.treeData, textValue)
        }
        this.state.autoExpandParent = true;
        this.setState({ searchText: textValue, expandedKeys: this.state.searchExpandedKeys })
    }
    //获取搜索搜索字段的展开树。
    getSearchOpenKey(data, searchText) {
        if (data && data.length > 0) {
            data.forEach((item) => {
                let index = searchText.length > 0 ? item.name.indexOf(searchText) : -1;
                if (index > -1) {
                    //if(item[childKey]&&item[childKey].length>0){
                    this.state.searchExpandedKeys.push(item["id"])
                    /* let keyIdArry=item[keyId].split('-')
                     keyIdArry.forEach((i)=>{
                        this.state.searchExpandedKeys.push(i)
                     })*/
                    // }
                }
                this.getSearchOpenKey(item["child"], searchText)
            })
        }
    }

    contributeTree = () => {
        const {contribute} = this.state;
        this.setState({
            contribute: !contribute,
        })
    }

    setCollect = (item) => {
        let url = "";
        if(item.collect) { // 取消收藏
            url = cancelCollectionUrl;
        } else { // 收藏
            url = collectUrl;
        }
        this.request({
            url: url,
            body:{nodeId:item.id},
            method:"post",
            callBack: (res) => {
                this.getNodes()
            },
            errorCallBack: (e) => {
                message.error(e)
            }
        })
    };

    onSelect = (selectedKeys, info) => {
        const titleeName = [];
        this.setState({selectedKeys});
    };

    onCheck = (checkedKeys, info) => {
        const titleeName = [];
        info.checkedNodes.forEach(item => {
            titleeName.push(item.props.title);
        });
        console.log('onCheck', checkedKeys, info);
        this.setState({
            titleeName: titleeName,
            checkedKeys
        })
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,//这个属性要在这里面使用fasle,不然如果子节点打开，关闭父节点关闭不了，点击没反应哦，重要操作。
        });
    };

}